"use strict";
var $offset;
$(document).foundation();
(function ($, window) {
    var LRHome = function (a) {};
    LRHome.prototype = {
        initialize: function () {
            $offset = $('header.principal').offset();
            this.headerFixed()
            this.bannerQuotes();
            this.menuMobile();
            this.initEvents();
        },
        bannerQuotes: function () {
            var timeoutId = null;

            function calculateLeft() {
                var l1 = $('.list-first').offset().left - $('.quote-banner-container').offset().left;
                var l2 = $('.list-second').offset().left - $('.quote-banner-container').offset().left;
                var ret = l1 < 0 && l2 < 0 ? (l1 < l2 ? l2 : l1) : (l1 > l2 ? l2 : l1);
                // ret = Math.abs(ret) > $('.list-first').innerWidth() ? (-1 * $('.list-first').innerWidth()) : ret;
                return ret;
            }

            function removeLeft(ll) {
                var x = $('.list-first').innerWidth();
                var seconds = (x + ll) / x * 50;
                timeoutId = setTimeout(function () {
                    $('.list-first').removeClass('move-list-first').css("left", '');
                    $('.list-second').removeClass('move-list-second').css("left", '');
                    setTimeout(function() {
                        $('.list-first').addClass('move-list-first');
                        $('.list-second').addClass('move-list-second');
                    }, 100);
                }, seconds * 1000)
            }
            var qBannerIsPlayed = true;

            $('.quote-banner-container').mouseover(function () {
                if (qBannerIsPlayed) {
                    clearTimeout(timeoutId);
                    var ll = calculateLeft();
                    $('.list-first').removeClass('move-list-first').css("left", ll + "px");
                    $('.list-second').removeClass('move-list-second').css("left", ll + "px");
                }
            });
            $('.quote-banner-container').mouseleave(function () {
                if (qBannerIsPlayed) {
                    var ll = calculateLeft();
                    $('.list-first').addClass('move-list-first').css("left", ll + "px");
                    $('.list-second').addClass('move-list-second').css("left", ll + "px");
                    removeLeft(ll);
                }
            });
            $('.playSlideQuotes').click(function () {
                if (qBannerIsPlayed) {
                    clearTimeout(timeoutId);
                    var ll = calculateLeft();
                    $('.list-first').removeClass('move-list-first').css("left", ll + "px");
                    $('.list-second').removeClass('move-list-second').css("left", ll + "px");
                    $('.playSlideQuotes i').removeClass('icon-pause').addClass('icon-play_arrow');
                } else {
                    var ll = calculateLeft();
                    $('.list-first').addClass('move-list-first').css("left", ll + "px");
                    $('.list-second').addClass('move-list-second').css("left", ll + "px");
                    $('.playSlideQuotes i').removeClass('icon-play_arrow').addClass('icon-pause');
                    removeLeft(ll);
                }
                qBannerIsPlayed = !qBannerIsPlayed;
            });
        },
        headerFixed: function () {
            if ($offset) {
                var scrollTop = $(window).scrollTop();
                if ($offset.top < scrollTop) {
                    $('header.principal').addClass("fixed");
                    $('main.principal').addClass("fixed");
                } else {
                    $('header.principal').removeClass("fixed")
                    $('main.principal').removeClass("fixed");
                }
            }
        },
        menuMobile: function () {
            $('.position-top').css({
                'height': $(window).height() + 'px'
            });
            $('#section-menu-btn').click(function () {
                var a = $('header .sectionMenu').toggleClass('open');
                $('#section-menu-btn').toggleClass('icon-menu').toggleClass('icon-close');
            });
            $('#open-menu-button').click(function () {
                var b = $('.off-canvas').attr("aria-hidden", "false");
                var c = 0;
                var e = $('.off-canvas').innerHeight();
                b.css({
                    '-webkit-transform': 'translate(0px, ' + c + 'px)',
                    '-moz-transform': 'translate(0px,' + c + 'px)',
                    '-ms-transform': 'translate(0px,' + c + 'px)',
                    '-o-transform': 'translate(0px,' + c + 'px)',
                    'transform': 'translate(0px,' + c + 'px)',
                });
                var d = $('.off-canvas-content');
                d.css({
                    '-webkit-transform': 'translate(0px, ' + e + 'px)',
                    '-moz-transform': 'translate(0px,' + e + 'px)',
                    '-ms-transform': 'translate(0px,' + e + 'px)',
                    '-o-transform': 'translate(0px,' + e + 'px)',
                    'transform': 'translate(0px,' + e + 'px)',
                });
                $('body').addClass('unscrollable');

            });
            $('.close-button').click(function () {
                $('body').removeClass('unscrollable');
                var b = $('.off-canvas').attr("aria-hidden", "true");
                var c = $('.off-canvas').innerHeight();
                var e = 0;
                c = -c;
                b.css({
                    '-webkit-transform': 'translate(0px, ' + c + 'px)',
                    '-moz-transform': 'translate(0px,' + c + 'px)',
                    '-ms-transform': 'translate(0px,' + c + 'px)',
                    '-o-transform': 'translate(0px,' + c + 'px)',
                    'transform': 'translate(0px,' + c + 'px)'
                });
                var d = $('.off-canvas-content');
                d.css({
                    '-webkit-transform': 'initial',
                    '-moz-transform': 'initial',
                    '-ms-transform': 'initial',
                    '-o-transform': 'initial',
                    'transform': 'initial',
                });
            });
        },
        initEvents: function () {
            $(window).scroll(window.LRHome.headerFixed);
        }
    };
    window.LRHome = new LRHome();
    window.LRHome.initialize();
})(jQuery, this, this.document, undefined);